import React from "react";
import { UseFormReturn } from "react-hook-form/dist/types/form";
import { useTranslation } from "react-i18next";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { apiOrganization } from "../../../../../../../../../services/Api/Organization/apiOrganization";
import { ApplicationUpdateApi } from "../../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<ApplicationUpdateApi>;
}

const MultiLocationInstallationForm = ({ form }: Props) => {
	const { t } = useTranslation();
	const {
		formState: { errors },
		control,
	} = form;

	const getExternalOrganizations = (search: string, params: Record<string, any>) => {
		return apiOrganization.getAppsLocations(search, params);
	};

	return (
		<FormSelectGroup
			control={control}
			getOptionLabel={(opt) => opt.name}
			getOptionValue={(opt) => opt.id}
			loadOptions={getExternalOrganizations}
			errors={errors}
			name={"external_organization_id"}
			label={t("common.word.location", { ns: "lib" })}
			data-testid="external_organization_id"
		/>
	);
};
export default MultiLocationInstallationForm;
